/**
 * Вкладки страницы проекта — ШАГИ работы (задача Оли №331: «нужно разделить по табам шаги. Первый —
 * генерация ракурсов, второй — создание видео… третье — монтаж»).
 *
 * Отдельный модуль без импортов: его грузит `node --test`, а страница — как обычный модуль.
 * У ролика «из кадра» шага три, и они пронумерованы; у ролика «из платья» шагов четыре (первым
 * бывает и сценарий, и кадры), поэтому там номеров нет, а порядок вкладок прежний — чтобы не ломать
 * привычку тех, кто ходит в такие проекты с 06.10.
 */

export type Tab = "shots" | "scenario" | "video" | "cut";

export type TabItem = { value: Tab; label: string };

const FRAME_TABS: TabItem[] = [
  { value: "shots", label: "1 · Ракурсы" },
  { value: "video", label: "2 · Видео" },
  { value: "cut", label: "3 · Монтаж" },
];

const DRESS_TABS: TabItem[] = [
  { value: "shots", label: "Кадры" },
  { value: "scenario", label: "Сценарий" },
  { value: "video", label: "Видео" },
  { value: "cut", label: "Монтаж" },
];

/** Вкладки по виду проекта; у проекта без видео их не показывают вовсе. */
export const tabsFor = (origin: "frame" | "dress"): TabItem[] => (origin === "frame" ? FRAME_TABS : DRESS_TABS);

/** Вкладка из адреса; неизвестная или недоступная этому проекту — первый шаг. */
export function tabOf(raw: string | null, allowed: readonly TabItem[]): Tab {
  const known: Tab[] = ["shots", "scenario", "video", "cut"];
  const t = known.find((x) => x === raw) ?? "shots";
  return allowed.some((x) => x.value === t) ? t : "shots";
}
